import(/* webpackMode: "eager" */ "/app/app/boticario/page.tsx");
